export const shadows = {
  xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  'stroke.secondary': '0px 0px 0px 1px var(--chakra-colors-stroke-secondary)',
  outline: '0px 0px 0px 1px rgba(82, 109, 206, 0.5)',
  'outline-solid': '0px 0px 0px 1px rgba(82, 109, 206, 1)',
  'outline-solid-2px': '0px 0px 0px 2px rgba(82, 109, 206, 1)',
  hover: '0px 0px 0px 1px #C5CDD3',
  invalid: '0px 0px 0px 1px #DC392E',
  'invalid-2px': '0px 0px 0px 2px #DC392E',
  'drop-1': '0rem 0.25rem 0.5rem rgba(15, 15, 15, 0.04)',
  'drop-2':
    '0px 9px 24px rgba(15, 15, 15, 0.15), 0px 3px 6px rgba(15, 15, 15, 0.1);',
  inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  none: 'none',
  'dark-lg':
    'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
}
